import React, { useMemo, useState } from "react";
import JobFilters from "./JobFilters";
import JobCard from "./JobCard";

const OpenPositions = ({ jobs }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [department, setDepartment] = useState("All");
  const [selectedJob, setSelectedJob] = useState(null);

  const filteredJobs = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();

    return jobs.filter((job) => {
      const matchesDepartment =
        department === "All" || job.department === department;

      const matchesSearch =
        !search ||
        job.title.toLowerCase().includes(search) ||
        job.department.toLowerCase().includes(search) ||
        job.skills.some((skill) => skill.toLowerCase().includes(search));

      return matchesDepartment && matchesSearch;
    });
  }, [jobs, searchTerm, department]);

  const handleApply = (job) => {
    const subject = `Application for ${job.title}`;

    const body = `Dear Belageri Technologies Hiring Team,

I would like to apply for the position of ${job.title}.

Job Details:
Position: ${job.title}
Department: ${job.department}
Location: ${job.location}
Experience: ${job.experience}

Please find my resume attached for your consideration.

Thank you.

Regards,
[Your Name]
[Phone Number]
[Email Address]`;

    const gmailUrl =
      `https://mail.google.com/mail/?view=cm&fs=1` +
      `&to=contactus@belageri.com` +
      `&su=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, "_blank");
  };

  return (
    <section className="open-positions" id="open-positions">
      <div className="careers-container">
        <div className="section-heading section-heading--jobs">
          <div>
            <span className="section-heading__eyebrow">OPPORTUNITIES</span>

            <h2 className="section-heading__title">
              Find your next opportunity.
            </h2>
          </div>

          <p className="section-heading__description">
            Explore our current openings and find a role where your skills and
            ambitions can make an impact.
          </p>
        </div>

        <JobFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          department={department}
          setDepartment={setDepartment}
        />

        {filteredJobs.length > 0 ? (
          <div className="jobs-grid">
            {filteredJobs.map((job) => (
              <JobCard key={job.id} job={job} onViewJob={setSelectedJob} />
            ))}
          </div>
        ) : (
          <div className="jobs-empty">
            <span className="jobs-empty__icon">⌕</span>

            <h3>No positions found</h3>

            <p>Try changing your search or department filter.</p>
          </div>
        )}

        {selectedJob && (
          <div
            className="job-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="job-modal-title"
            onClick={() => setSelectedJob(null)}
          >
            <div
              className="job-modal__content"
              onClick={(event) => event.stopPropagation()}
            >
              <button
                type="button"
                className="job-modal__close"
                onClick={() => setSelectedJob(null)}
                aria-label="Close job details"
              >
                ×
              </button>

              <span className="job-modal__department">
                {selectedJob.department}
              </span>

              <h3 id="job-modal-title">{selectedJob.title}</h3>

              <div className="job-modal__meta">
                <span>{selectedJob.location}</span>
                <span>{selectedJob.type}</span>
                <span>{selectedJob.experience}</span>
              </div>

              <p className="job-modal__description">
                {selectedJob.description}
              </p>

              <h4>Key skills</h4>

              <div className="job-modal__skills">
                {selectedJob.skills.map((skill) => (
                  <span key={skill}>{skill}</span>
                ))}
              </div>

              <button
                type="button"
                className="job-modal__apply"
                onClick={() => handleApply(selectedJob)}
              >
                Apply for this position
                <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default OpenPositions;
